import { createSvgIcon } from "@mui/material";

export const PdfIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46" fill="currentColor">
        <g>
            <path d="M203.75,59.22h-93.06c-11.31,0-20.5,9.2-20.5,20.5v93.06c0,11.31,9.19,20.5,20.5,20.5h93.06
                c11.3,0,20.5-9.19,20.5-20.5V79.72C224.25,68.42,215.05,59.22,203.75,59.22z M207.25,172.78c0,1.9-1.61,3.5-3.5,3.5h-93.06
                c-1.9,0-3.5-1.6-3.5-3.5V79.72c0-1.89,1.6-3.5,3.5-3.5h93.06c1.89,0,3.5,1.61,3.5,3.5V172.78z"/>
            <path d="M76.22,203.75V92.64h-17v111.1c0,11.3,9.2,20.5,20.5,20.5h110.73v-17H79.72
                C77.82,207.25,76.22,205.64,76.22,203.75z"/>
            <path d="M138.86,110.59c-1.99-1.9-8.06-1.73-11.14-1.86c-0.82-0.03-1.66-0.02-2.53-0.02h-8.37v41.12h8.37v-17
                c0.39,0,1.11-0.02,1.66-0.01c1.09,0.02,1.7,0.01,2.73,0.01c3.1,0,7,0.44,9.06-1.52c1.44-1.37,2.05-4.28,2.05-6.4v-7.21
                C140.69,114.88,140.45,112.11,138.86,110.59z M133.69,124.91c0,0.17-0.02,0.27-0.02,0.27c-0.36,0.43-2.26,0.68-6.73,0.65
                c-0.68,0-1.27-0.06-1.75-0.06v-10c0.93,0,1.83-0.02,2.7-0.04c1.86-0.05,4.94,0.02,5.49,0.56c0.07,0.07,0.31,0.35,0.31,1.41V124.91z"/>
            <path d="M173.88,123.45c0-4.92,0.07-9.67-1.91-12.12c-1.98-2.45-6.04-2.61-10.04-2.61h-4.72h-7.8v41.12h7.8h4.7
                c2.66,0,5.81,0.18,7.59-0.92s3.1-2.73,3.99-4.91c0.89-2.18,0.4-5.63,0.4-8.91V123.45z M165.18,141.95c-1.46,0.13-0.56,0.05-2.91,0
                l-5.06-0.12v-25.36h4.85c2.91,0,4.08-0.29,4.14,2.11c0.06,2.53,0,5.34-0.06,8.39v9.51C166.15,140.08,166.5,141.48,165.18,141.95z"/>
            <polygon points="198.87,117.62 198.83,108.62 188.76,108.67 182.55,108.67 182.55,149.83 191.55,149.83 191.55,133.75
                198.87,133.72 198.84,124.72 191.55,124.75 191.55,117.66"/>
        </g>
    </svg>,
    'PdfIcon'
)
